"use client";

import { useEffect, useState } from "react";

export function useDeferredMount(timeoutMs = 2000): boolean {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const mount = () => {
      if (!cancelled) setMounted(true);
    };

    if (typeof requestIdleCallback === "function") {
      const id = requestIdleCallback(mount, { timeout: timeoutMs });
      return () => {
        cancelled = true;
        cancelIdleCallback(id);
      };
    }

    const id = window.setTimeout(mount, 1);
    return () => {
      cancelled = true;
      window.clearTimeout(id);
    };
  }, [timeoutMs]);

  return mounted;
}
